// extracted by mini-css-extract-plugin
module.exports = {"avatar":"AdvertiserChip__avatar___1Bw1C","name":"AdvertiserChip__name___3Ysks"};